// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-23T21:49:16.874Z
// Property: Sycamore Creek Apartments (ID: 6767906449167512)
// Collections: 32 amenities, 2 floorplans (live), 31 photos, 34 POIs, 2 reviews, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162458",
  "multihub_property_id": "6767906449167512",
  "property_external_id": "5685519",
  "property_zillow_url": "https://www.zillow.com/apartments/sidney-oh/sycamore-creek-apartments/5Xr3wC/",
  "property_apartments_url": "https://www.apartments.com/sycamore-creek-sidney-oh/zyp845x/",
  "property_google_business_url": "https://www.google.com/maps/place/Sycamore+Creek+Apartments/@40.2982708,-84.1684156,904m/data=!3m2!1e3!4b1!4m6!3m5!1s0x883f0f3b8f48aad5:0x33f8e1cc23d97566!8m2!3d40.2982708!4d-84.1684156!16s%2Fg%2F1tql5g20?entry=ttu&g_ep=EgoyMDI2MDUyNy4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "58535747641",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": "RealPage",
  "property_status": null,
  "property_slug": "sycamore-creek-apartments",
  "property_name": "Sycamore Creek Apartments",
  "property_website_url": "https://www.sycamorecreekapartmentliving.com/",
  "property_domain": "https://www.sycamorecreekapartmentliving.com/",
  "property_address": "776 Country Side Ln",
  "property_full_address": "776 Country Side Ln, Sidney, OH 45365",
  "property_address_1": "776 Country Side Ln",
  "property_address_2": null,
  "property_address_city": "Sidney",
  "property_address_state": "OH",
  "property_address_zip_full": "45365-5205",
  "property_address_zip": "45365",
  "property_address_country": "US",
  "property_address_county": "Shelby County",
  "property_neighborhood_address": "Ohio South Area",
  "property_address_latitude": "40.2983331",
  "property_address_longitude": "-84.16842249999999",
  "property_email": "sycamorecreek@dietzpropertygroup.com",
  "property_phone": "(937) 493-0554",
  "property_call_tracking_phone": "937-493-0554",
  "property_company_name": "Dietz Property Group",
  "property_company_url": "https://www.dietzpropertygroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Sycamore Creek in Sidney, OH, our spacious two and three-bedroom apartments offer the perfect blend of comfort and convenience. Enjoy high-speed internet, a pet-friendly environment, and on-site amenities like a playground and business center. Embrace a lifestyle of ease—schedule your tour or browse available homes today!",
  "property_long_description": "Nestled in the heart of Sidney, Ohio, Sycamore Creek offers apartment homes designed for the way you actually live. With spacious floor plans, in-unit laundry, and a community built around comfort and connection, you'll find everything you need close to home — and even more right outside your door. Major employers, local dining, and the charm of downtown Sidney are just minutes away. Sycamore Creek: Where everyday life feels a little easier.Sycamore Creek Apartments in Sidney, OH offers spacious one- and two-bedroom homes with modern finishes, in-unit laundry, and a welcoming community atmosphere. Conveniently located near top employers and downtown Sidney's best dining and shopping.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-abaa-73ad-8724-f8af095d63a7.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of apartment building entrance with brick and siding.",
    "public_id": "019e46e2-abaa-73ad-8724-f8af095d63a7",
    "storage_key": "property/6767906449167512/019e46e2-abaa-73ad-8724-f8af095d63a7.webp",
    "width": 900,
    "height": 600
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "96",
  "property_year_built": "2024",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.91666666666666",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": "200",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "50",
  "property_pet_restrictions": "No more than 2 animals are permitted in any unit.",
  "property_pet_policy_description": "CATS are allowed at this property: YES. Weight limit: 50 lbs each. Additional deposit: $200 per cat. Additional monthly rent: $25/month per cat. DOGS are allowed at this property: YES. Weight limit: 50 lbs each. Additional deposit: $200 per dog. Additional monthly rent: $25/month per dog. No more than 2 animals are permitted in any unit.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://sycamorecreek.loftliving.com/",
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019ef548-63b4-73db-8e68-86baaf759c0b.webp",
  "property_primary_logo_media": {
    "alt_text": "Sycamore Creek Apartments logo",
    "public_id": "019ef548-63b4-73db-8e68-86baaf759c0b",
    "storage_key": "property/6767906449167512/019ef548-63b4-73db-8e68-86baaf759c0b.webp",
    "width": 2000,
    "height": 2000
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019ef548-63b4-73db-8e68-86baaf759c0b.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Sycamore Creek Apartments logo",
    "public_id": "019ef548-63b4-73db-8e68-86baaf759c0b",
    "storage_key": "property/6767906449167512/019ef548-63b4-73db-8e68-86baaf759c0b.webp",
    "width": 2000,
    "height": 2000
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019ef548-62b6-72ab-9aa3-2102f13a2a56.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Sycamore Creek Apartments logo.",
    "public_id": "019ef548-62b6-72ab-9aa3-2102f13a2a56",
    "storage_key": "property/6767906449167512/019ef548-62b6-72ab-9aa3-2102f13a2a56.webp",
    "width": 2000,
    "height": 2000
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019dffdc-8ac5-716c-b71f-1f453648e537.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019d638a-0da7-727f-ad43-3bd78629f61b.webp",
  "property_company_logo_media": {
    "alt_text": "Dietz Property Group logo",
    "public_id": "019d638a-0da7-727f-ad43-3bd78629f61b",
    "storage_key": "company/5767906449162458/019d638a-0da7-727f-ad43-3bd78629f61b.webp",
    "width": 992,
    "height": 329
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-379b-72ca-a5a9-1262d569a77e.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "DPG logo",
    "public_id": "019e28a2-379b-72ca-a5a9-1262d569a77e",
    "storage_key": "company/5767906449162458/019e28a2-379b-72ca-a5a9-1262d569a77e.webp",
    "width": 344,
    "height": 329
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "DPG logo in white on black background.",
    "public_id": "019e28a2-7e6e-752b-a7e2-54f21a5cd171",
    "storage_key": "company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp",
    "width": 344,
    "height": 329
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#000",
  "property_color_4": null,
  "property_color_3": "#757B77",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 3",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "851 - 1001",
  "property_sqft_min": "851",
  "property_sqft_max": "1,001",
  "property_price_range": "839 - 1049",
  "property_price_min": "839",
  "property_price_max": "1049",
  "property_available_units": 3,
  "property_facebook_url": "https://www.facebook.com/media/set/?vanity&set=a.10151211954784491",
  "property_instagram_url": null,
  "property_twitter_url": "https://twitter.com/pre_three",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ1apIjzsPP4gRZnXZI8zh-DM",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/sycamore-creek-apartments-tucson",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Sycamore Creek",
  "property_home_romance_title": "Embrace Your New Life in Our Charming Apartment Community",
  "property_home_amenities_blurb": "<p>Welcome to Sycamore Creek in Sidney, OH, where spacious two- and three-bedroom tax credit apartments redefine comfort. Enjoy modern amenities like a fully equipped kitchen, private patios, and an on-site business center. With pet-friendly policies and a playground, it’s the perfect place for families and four-legged friends alike.</p>",
  "property_home_floorplans_blurb": "At Sycamore Creek in Sidney, OH, comfort meets style in our thoughtfully designed two and three-bedroom apartments. Each layout offers a seamless blend of spacious living and modern amenities. Ready to elevate your lifestyle? Browse our available apartment homes and find the perfect floor plan that suits your needs today!",
  "property_home_gallery_blurb": "At Sycamore Creek in Sidney, OH, our spacious two- and three-bedroom apartments offer a perfect blend of comfort and convenience. Enjoy pet-friendly living with amenities like a fully equipped kitchen, emergency maintenance, and a relaxing balcony/patio. Picture yourself thriving in a community designed for modern lifestyles!",
  "property_home_neighborhood_blurb": "At Sycamore Creek in Sidney, OH, your new home is surrounded by vibrant community life. Enjoy local treasures like the historic Ross Covered Bridge, scenic Tawawa Park, and engaging events at Sidney Memorial Stadium. Dive into a unique blend of convenience and culture, all just steps away from your front door!",
  "property_home_reviews_blurb": "Nestled in the heart of Sidney, OH, Sycamore Creek shines as a vibrant apartment community. Residents rave about the “friendly atmosphere and spacious layouts,” making it a perfect home for everyone. Dive into authentic experiences and see what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "<p>At Sycamore Creek in Sidney, OH, life thrives beyond your front door. Immerse yourself in local culture with nearby gems like the Amos Memorial Public Library and the historic Ross Covered Bridge. Embrace adventure at Tawawa Park or explore the scenic Canal Feeder Trail. Uncover the best affordable apartments rich in connection!</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>At Sycamore Creek, our spacious two- and three-bedroom affordable apartments in Sydney, OH offer the perfect blend of comfort and convenience. Enjoy modern amenities like a fully equipped kitchen, on-site management, and a delightful playground. With high-speed internet and emergency maintenance, you'll feel right at home. Join our pet-friendly community today!</p>",
  "property_applynow_blurb": "<p>At Sycamore Creek, we offer affordable housing in Sydney, OH, where your ideal living experience awaits. Choose from spacious two and three-bedroom floor plans, complete with balconies, fully equipped kitchens, and pet-friendly amenities. Enjoy a vibrant community with emergency maintenance, a playground, and high-speed internet access. Start leasing your new home online today!</p><p><br></p>",
  "property_contactus_blurb": "<p>At Sycamore Creek in Sidney, OH, you'll find affordable two and three-bedroom floor plans tailored for your lifestyle. Each space combines comfort and style, creating the perfect home. Have questions? Our friendly leasing team is ready to assist you in finding your ideal apartment. Reach out today!</p>",
  "property_faqs_blurb": "At Sycamore Creek in Sidney, OH, your ideal home awaits! Whether you seek a spacious two-bedroom or a luxurious three-bedroom layout, our diverse floor plans cater to every lifestyle. Curious about community life? Browse our FAQs page to uncover insights and answers tailored just for you!",
  "property_floorplans_blurb": "<p>At Sycamore Creek in Sidney, OH, our affordable apartment community offers thoughtfully designed two and three-bedroom floor plans that cater to every lifestyle. Each spacious layout offers modern comforts and unique features. Browse our available apartment homes today and find the perfect space to embrace your next chapter.</p>",
  "property_gallery_blurb": "<p>At Sycamore Creek in Sidney, OH, our vibrant community complements your lifestyle with spacious two and three-bedroom apartments. Enjoy modern amenities like a fully equipped kitchen, high-speed internet, and a pet-friendly environment. Picture yourself relaxing on your balcony or having fun at our playground. Your new affordable apartment awaits.</p>",
  "property_interactivemap_blurb": "At Sycamore Creek in Sidney, OH, your ideal home awaits! Choose from spacious two and three-bedroom floor plans, complete with modern amenities like high-speed internet, a fully equipped kitchen, and beautiful balconies. Unleash your lifestyle with our interactive community map to find the perfect apartment today!",
  "property_pets_blurb": "<p>Sycamore Creek offers a vibrant community and pet-friendly, affordable apartments in Sydney, OH. Here, both you and your furry friends will feel at home, with spacious apartments and a welcoming atmosphere. Enjoy the perfect blend of comfort and convenience, and embrace life in a place where your pets can thrive!</p>",
  "property_referafriend_blurb": "At Sycamore Creek in Sidney, OH, your perfect home awaits! Choose from spacious two and three-bedroom floor plans, ideal for sharing life’s moments with great friends. Enhance your living experience—refer a friend today and watch your community flourish with familiar faces and new connections!",
  "property_residentaccess_blurb": "At Sycamore Creek in Sidney, OH, your ideal home awaits in our spacious two and three-bedroom floor plans. Effortlessly manage your living experience through our resident portal—pay rent, schedule maintenance, and connect with community updates. Experience seamless living at Sycamore Creek, where comfort meets convenience.",
  "property_reviews_blurb": "At Sycamore Creek in Sidney, OH, our residents love the vibrant community atmosphere. One resident raved, “The friendly neighbors and beautiful surroundings make it feel like home!” Dive into our reviews and see what our residents have to say about life at Sycamore Creek—your new sanctuary awaits!",
  "property_created_at": "1779305668087",
  "property_scheduletour_blurb": "<p>At Sycamore Creek in Sidney, OH, affordable housing awaits with spacious two and three-bedroom floor plans designed for modern living. Schedule a tour today and experience a vibrant community where comfort meets convenience. Curious about our residents' experiences? Their stories await to inspire your next move!</p>",
  "property_thankyou_blurb": "Thank you for reaching out to Sycamore Creek in Sidney, OH! We’re excited to help you find your perfect space. Our diverse two- and three-bedroom floor plans offer comfort and style, tailored to your lifestyle. Expect a prompt response from our dedicated team—your new home awaits!",
  "property_virtualtours_blurb": "<p>At Sycamore Creek, our spacious two- and three-bedroom apartments offer a perfect blend of comfort and style. Experience the welcoming atmosphere and diverse floor plans that fit your lifestyle. Ready to envision your new home? Take a virtual tour of our Sydney, OH, affordable apartments today!</p>",
  "property_copyright": "2026 All Rights Reserved. Sycamore Creek",
  "property_seo_title_home": "Affordable Apartments in Sidney, OH | Sycamore Creek | Home",
  "property_seo_description_home": "Discover Sycamore Creek Apartments in Sidney, OH, offering 2 & 3 bedroom apartments for rent. Explore available floor plans and schedule your tour today.",
  "property_seo_title_floorplans": "Affordable 1-Bedroom Apartments in Sidney, OH | Floor Plans",
  "property_seo_description_floorplans": "Browse the two-, and three-bedroom apartment homes available at Sycamore Creek Apartments in Sidney, OH. Find the floor plan that fits your needs.",
  "property_seo_title_amenities": "Affordable Apartment Community in Sidney, OH | Amenities",
  "property_seo_description_amenities": "Our amenities at Sycamore Creek make coming home easy and comfortable at our affordable apartments located in Sidney, OH.",
  "property_seo_title_gallery": "Affordable Housing in Sidney, OH | Sycamore Creek | Gallery",
  "property_seo_description_gallery": "Explore the gallery at Sycamore Creek Apartments and preview apartment interiors, community spaces, and everything that makes this community feel like home.",
  "property_seo_title_virtualtours": "Virtual Tours | Sycamore Creek Apartments",
  "property_seo_description_virtualtours": "Discover Sycamore Creek in Sidney, OH! Tour our spacious two and three-bedroom apartments online. Your new lifestyle awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Sycamore Creek Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Sycamore Creek in Sidney, OH. Check our interactive community map for spacious 2- and 3-bedroom apartments and great amenities!",
  "property_seo_title_neighborhood": "Affordable 2-Bedroom Apartments in Sidney, OH | Neighborhood",
  "property_seo_description_neighborhood": "Learn more about the neighborhood surrounding Sycamore Creek Apartments, with convenient access to shopping, dining, parks, employers, and everyday essentials.",
  "property_seo_title_contact": "Affordable Sidney, OH Apartments | Contact",
  "property_seo_description_contact": "Contact the leasing team at Sycamore Creek Apartments in Sidney, OH. We're here to answer your questions and help you find your next affordable apartment home.",
  "property_seo_title_faqs": "FAQs | Apartments in Sidney, OH",
  "property_seo_description_faqs": "Find answers to your questions at Sycamore Creek in Sidney, OH! Learn about our spacious floor plans, amenities, and pet-friendly living. Start exploring now!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Sidney, OH",
  "property_seo_description_reviews": "At Sycamore Creek in Sidney, OH, our residents love spacious layouts and top-notch amenities. Check out their reviews and join our vibrant community today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Sidney, OH",
  "property_seo_description_applynow": "Discover modern living at Sycamore Creek in Sidney, OH! Enjoy spacious 2 & 3-bedroom layouts, pet-friendly amenities, and exceptional management.",
  "property_seo_title_residentaccess": "Resident Access | Sycamore Creek",
  "property_seo_description_residentaccess": "Log in to Sycamore Creek's resident portal for easy rent payments, quick maintenance requests, and a seamless living experience in charming Sidney, OH!",
  "property_seo_title_referafriend": "Refer A Friend | Sycamore Creek",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Sycamore Creek in Sidney, OH, and enjoy exclusive perks together in a vibrant community.",
  "property_seo_title_scheduletour": "Tax-Credit Apartments in Sidney, OH | Sycamore Creek | Tour",
  "property_seo_description_scheduletour": "Schedule a personal tour of Sycamore Creek Apartments in Sidney, OH, and see for yourself why residents enjoy calling our affordable apartment community home.",
  "property_seo_title_privacy": "Privacy Policy | Sycamore Creek",
  "property_seo_description_privacy": "At Sycamore Creek in Sidney, OH, your privacy matters. Learn how we protect your information while you enjoy a vibrant community. View our privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | Sycamore Creek",
  "property_seo_description_accessibility": "At Sycamore Creek in Sidney, OH, we prioritize digital inclusion. Experience a community where everyone can connect and thrive together. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Sycamore Creek",
  "property_seo_description_sitemap": "Uncover the layout of Sycamore Creek in Sidney, OH. Navigate through our sitemap to find your ideal apartment and community amenities tailored for you!",
  "property_seo_title_thankyou": "Thank You | Sycamore Creek",
  "property_seo_description_thankyou": "Thanks for reaching out! A member of our Sycamore Creek team in Sidney, OH will connect with you soon to help you find your perfect new home.",
  "property_seo_title_pets": "Pet-Friendly Affordable Apartments in Sidney, OH | Pets",
  "property_seo_description_pets": "We welcome your furry friends at Sycamore Creek Apartments in Sidney, OH. Check out our pet policy and make our community your home today.",
  "property_updated_at": "1790113565465",
  "amenities": [
    {
      "id": "custom_2786d597-2702-4cd1-9564-cef7df65702f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "24 Hour Amenity Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b919270d-cb11-4dc3-8480-4619655f44ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "Controlled Access",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5fb92314-ae07-4e31-8a69-49d8cd1fb7c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1f7e7a7f-0861-4abe-9363-bd103d625860",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "Property Manager on Site",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_86fb10e6-b7d9-48a4-80cd-3e82758f16a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "Furnished Units Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4df7d997-ade7-4746-b17d-376e34dc1e14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "Maintenance on site",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6c3f04e6-0aa9-4edd-92d6-6cc271a4dfca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0cfa069b-02a5-4e7c-886e-9ef54adc09e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "Walk-Up",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6b7b8dc0-590e-4ac8-9e95-3c9178dbd032",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "Gated Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3bbe8d21-b6e5-457f-ad6f-13cb20c87135",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7b534ee3-17d2-42d1-8583-50df51f58175",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "Intercom System",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7f9666e3-4ab7-4d1b-8133-d640ce4aa39f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ab92349e-a4a5-4fcc-967a-08c0570e9b68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e8f19882-27b7-46f1-b582-a0681250bb25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a226250a-eeb1-480a-95e1-f9de4ef508d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "Heating",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6b5aba29-01e6-49b8-bbdf-5f7823d56673",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "High Speed Internet Access",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c13af810-e25f-46f4-9fd6-f7289ce9c3d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "Tub/Shower",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fb84a9a2-b2e1-4a0c-b604-f805ce3933f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "Intercom",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2b58d11e-f544-4ca1-827a-703b17b1c98a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "Smoke Free",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_df96ebba-9a7b-4c2b-a87c-32facc94cf14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "Wheelchair Accessible (Rooms)",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d076a68d-6276-44a8-91bb-e4c643d223ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_23794e51-dc36-46b5-b1ed-5d2f0d809a65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "Disposal",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7fed309b-71b9-4150-8e8a-d2245c3b4a83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "Kitchen",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0b69cbb8-249f-480f-ae9e-2a5085a1fa73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3267ad48-c512-4dc3-bd02-120f55d053dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "Range",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eca99569-880f-4222-92c4-0f8480ea55c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e230da59-8776-4f89-99f5-e3f7394fb427",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "Carpet",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9ae778eb-fd6e-49af-a380-38d8b38956af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "Dining Room",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7c96e6d0-a44e-43c1-8ad4-3b022b94b2d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "Furnished",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eedf435d-12ac-48b3-a264-d0e4622ab3b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "Vinyl Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_28df7bbc-8ca8-4dbd-a875-beb896857ee9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e034c07a-d08a-43ff-9705-8a1f1c81f34d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "external_id": "false",
      "title": "Balcony/Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_f8bbbb8c-dba8-4e90-af89-ba0af2077788",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019f667c-7bc7-73cb-973f-bdcba6a6b184.webp",
      "image_media": {
        "alt_text": "Sycamore Creek Apartments monument sign with landscaping.",
        "public_id": "019f667c-7bc7-73cb-973f-bdcba6a6b184",
        "storage_key": "property/6767906449167512/019f667c-7bc7-73cb-973f-bdcba6a6b184.webp",
        "width": 3072,
        "height": 2134
      },
      "title": "Community",
      "description": "Welcome to Sycamore Creek Apartments, a premier community offering comfortable living spaces and a variety of amenities. Explore our beautiful grounds and find your perfect home.",
      "link": "",
      "alt_text": "Sycamore Creek Apartments monument sign with landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0e0c5099-f42a-4e49-b174-2f5eda19bf9a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e8f58-6672-7249-a7df-8e54e10deeb7.webp",
      "image_media": {
        "alt_text": "Exterior of a brick and vinyl apartment building with balconies and a grassy lawn.",
        "public_id": "019e8f58-6672-7249-a7df-8e54e10deeb7",
        "storage_key": "property/6767906449167512/019e8f58-6672-7249-a7df-8e54e10deeb7.webp",
        "width": 3072,
        "height": 1897
      },
      "title": "Community",
      "description": "This apartment building exterior features a charming brick facade combined with neutral vinyl siding, complete with private balconies and lush green landscaping.",
      "link": "",
      "alt_text": "Exterior of a brick and vinyl apartment building with balconies and a grassy lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0512d8ae-8cc0-40b4-a108-e547c616cc5a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e8f58-5b2c-7558-a92e-d16836e3689b.webp",
      "image_media": {
        "alt_text": "Exterior of a brick and siding apartment building with balconies and a green lawn.",
        "public_id": "019e8f58-5b2c-7558-a92e-d16836e3689b",
        "storage_key": "property/6767906449167512/019e8f58-5b2c-7558-a92e-d16836e3689b.webp",
        "width": 3072,
        "height": 1814
      },
      "title": "Community",
      "description": "View the exterior of this apartment building, featuring a classic brick facade, modern siding, and private balconies.",
      "link": "",
      "alt_text": "Exterior of a brick and siding apartment building with balconies and a green lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bc01f47e-fecb-48de-8814-d0479994ced3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e8f58-59a0-72ee-9c6b-fff6082c037b.webp",
      "image_media": {
        "alt_text": "Closet and vanity area in a bedroom with carpet and wood doors.",
        "public_id": "019e8f58-59a0-72ee-9c6b-fff6082c037b",
        "storage_key": "property/6767906449167512/019e8f58-59a0-72ee-9c6b-fff6082c037b.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Spacious closet and vanity area with a sink and mirror, adjacent to a bedroom. The room features neutral carpeting and classic wood doors, creating a comfortable and functional living space.",
      "link": "",
      "alt_text": "Closet and vanity area in a bedroom with carpet and wood doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6960ea44-bd0e-40ff-8550-f2eb930f6f73",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e8f58-630e-70d1-8b1f-b3242ec372c9.webp",
      "image_media": {
        "alt_text": "Playground with slides and climbing structures.",
        "public_id": "019e8f58-630e-70d1-8b1f-b3242ec372c9",
        "storage_key": "property/6767906449167512/019e8f58-630e-70d1-8b1f-b3242ec372c9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring slides and climbing structures for children.",
      "link": "",
      "alt_text": "Playground with slides and climbing structures.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0b10db74-2319-4e15-a4d1-b4d12cf443f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e8f58-49b1-76e3-8f89-0d8ce0aecb81.webp",
      "image_media": {
        "alt_text": "Exterior of a brick apartment building with a manicured lawn and shrubs.",
        "public_id": "019e8f58-49b1-76e3-8f89-0d8ce0aecb81",
        "storage_key": "property/6767906449167512/019e8f58-49b1-76e3-8f89-0d8ce0aecb81.webp",
        "width": 3072,
        "height": 1772
      },
      "title": "Community",
      "description": "Charming brick apartment building with a welcoming entrance and well-maintained landscaping.",
      "link": "",
      "alt_text": "Exterior of a brick apartment building with a manicured lawn and shrubs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_53a2407f-8529-4f0d-bad2-3f0497fa3f81",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e8f58-4696-73b8-9252-b04eec88a2e2.webp",
      "image_media": {
        "alt_text": "Interior view of a bedroom with neutral carpet and white walls. Two wooden doors are visible, one closed and one ajar, revealing another doorway.",
        "public_id": "019e8f58-4696-73b8-9252-b04eec88a2e2",
        "storage_key": "property/6767906449167512/019e8f58-4696-73b8-9252-b04eec88a2e2.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Step into comfort in this spacious bedroom, featuring plush neutral carpeting and clean white walls. Two elegant wooden doors offer access to your private sanctuary.",
      "link": "",
      "alt_text": "Interior view of a bedroom with neutral carpet and white walls. Two wooden doors are visible, one closed and one ajar, revealing another doorway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e9c45c86-fcd2-4367-a3da-7a74e3a293a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e8f58-440c-7669-8c08-a888bb55921a.webp",
      "image_media": {
        "alt_text": "Empty living room with a wood door and sliding glass doors.",
        "public_id": "019e8f58-440c-7669-8c08-a888bb55921a",
        "storage_key": "property/6767906449167512/019e8f58-440c-7669-8c08-a888bb55921a.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Spacious living area featuring plush carpeting, a neutral color palette, and ample natural light from the sliding glass doors. Includes a view of the entryway and interior door.",
      "link": "",
      "alt_text": "Empty living room with a wood door and sliding glass doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_027fc187-2935-49c7-9028-5e731ebf8dd4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e8f58-3986-736e-8b7e-aa4f3888bd6c.webp",
      "image_media": {
        "alt_text": "Interior view of an apartment living area and kitchen pass-through.",
        "public_id": "019e8f58-3986-736e-8b7e-aa4f3888bd6c",
        "storage_key": "property/6767906449167512/019e8f58-3986-736e-8b7e-aa4f3888bd6c.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "This image shows a bright and spacious apartment interior, featuring a living area with carpet and a pass-through window to the kitchen.",
      "link": "",
      "alt_text": "Interior view of an apartment living area and kitchen pass-through.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f715c847-9129-4703-8a7f-1b495ab2e7e0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019f054c-3a35-776f-b90e-2ed424ceca17.webp",
      "image_media": {
        "alt_text": "Father lifting his young son up, both are laughing",
        "public_id": "019f054c-3a35-776f-b90e-2ed424ceca17",
        "storage_key": "property/6767906449167512/019f054c-3a35-776f-b90e-2ed424ceca17.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Lifestyle",
      "description": "A father happily lifts his son in the air, creating a moment of joy and connection. This image represents the vibrant lifestyle and family-friendly atmosphere of the community.",
      "link": "",
      "alt_text": "Father lifting his young son up, both are laughing",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6d0aecdd-6813-4bb5-b609-2ef28aebe7c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e8f58-373e-7760-9ac0-c68adb899d4d.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a window and neutral carpet.",
        "public_id": "019e8f58-373e-7760-9ac0-c68adb899d4d",
        "storage_key": "property/6767906449167512/019e8f58-373e-7760-9ac0-c68adb899d4d.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "An unfurnished bedroom featuring a large window with blinds, neutral-toned walls, and carpeted flooring, offering a blank canvas for personalization.",
      "link": "",
      "alt_text": "Empty bedroom with a window and neutral carpet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f5c2f0f6-722f-4992-bfc9-13cd69eafa92",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019f054c-2b1a-70d8-9bd4-575965874fcf.webp",
      "image_media": {
        "alt_text": "Couple eating dinner together in a modern kitchen",
        "public_id": "019f054c-2b1a-70d8-9bd4-575965874fcf",
        "storage_key": "property/6767906449167512/019f054c-2b1a-70d8-9bd4-575965874fcf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "Enjoy a cozy meal together in your spacious apartment kitchen. Perfect for shared moments and creating lasting memories.",
      "link": "",
      "alt_text": "Couple eating dinner together in a modern kitchen",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c94d8b35-7c67-4be2-a789-663d2a7b5851",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e8f58-2cc8-7655-ab3f-8e0fcdc303f2.webp",
      "image_media": {
        "alt_text": "Empty living room with carpet, white walls, and sliding glass door.",
        "public_id": "019e8f58-2cc8-7655-ab3f-8e0fcdc303f2",
        "storage_key": "property/6767906449167512/019e8f58-2cc8-7655-ab3f-8e0fcdc303f2.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Spacious living area with neutral carpeting and ample natural light from the sliding glass door. Perfect for creating your own personalized living space.",
      "link": "",
      "alt_text": "Empty living room with carpet, white walls, and sliding glass door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ec3fa50f-781f-4c5f-bf79-b6d9f156c6ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e8f58-26e1-722a-9f27-ac4f0354b079.webp",
      "image_media": {
        "alt_text": "Closet and vanity area in an apartment bedroom.",
        "public_id": "019e8f58-26e1-722a-9f27-ac4f0354b079",
        "storage_key": "property/6767906449167512/019e8f58-26e1-722a-9f27-ac4f0354b079.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Spacious closet with sliding doors and a vanity with a sink, perfect for getting ready in the morning. Located in a comfortable apartment bedroom.",
      "link": "",
      "alt_text": "Closet and vanity area in an apartment bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_73cfc994-c98c-485e-8526-e2642a0a8d8d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e8f58-21ce-7239-b8bd-7cb0f4b7f595.webp",
      "image_media": {
        "alt_text": "Laundry room with two washing machines, a water heater, and a utility sink.",
        "public_id": "019e8f58-21ce-7239-b8bd-7cb0f4b7f595",
        "storage_key": "property/6767906449167512/019e8f58-21ce-7239-b8bd-7cb0f4b7f595.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities equipped with washing machines, dryers, and a utility sink for your everyday needs.",
      "link": "",
      "alt_text": "Laundry room with two washing machines, a water heater, and a utility sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dafaf81c-ab27-4974-86fd-8e4a37b36756",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019f054c-3511-7779-a03e-59e7ff6f8b1b.webp",
      "image_media": {
        "alt_text": "People walking a dog on a leash in a park.",
        "public_id": "019f054c-3511-7779-a03e-59e7ff6f8b1b",
        "storage_key": "property/6767906449167512/019f054c-3511-7779-a03e-59e7ff6f8b1b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "Residents enjoying a stroll with their furry friend in the beautifully landscaped community park.",
      "link": "",
      "alt_text": "People walking a dog on a leash in a park.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5a2c130e-57ce-4649-9116-63cc49a960c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e8f58-116a-774e-95f9-df9251084902.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances, cabinetry, and a ceiling fan.",
        "public_id": "019e8f58-116a-774e-95f9-df9251084902",
        "storage_key": "property/6767906449167512/019e8f58-116a-774e-95f9-df9251084902.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "A clean and functional kitchen space featuring white appliances, ample cabinetry, and a ceiling fan for comfort.",
      "link": "",
      "alt_text": "Kitchen with white appliances, cabinetry, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ed7d7542-91c2-48fa-a939-1956d056fcd2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e8f58-0ac6-764d-b6cf-b2243dc64bd4.webp",
      "image_media": {
        "alt_text": "Empty bedroom with carpet, a large window, and a closet.",
        "public_id": "019e8f58-0ac6-764d-b6cf-b2243dc64bd4",
        "storage_key": "property/6767906449167512/019e8f58-0ac6-764d-b6cf-b2243dc64bd4.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Spacious bedroom with plush carpeting, a large window for natural light, and ample closet space. This room is ready for you to make it your own.",
      "link": "",
      "alt_text": "Empty bedroom with carpet, a large window, and a closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_49307be7-5a01-4e90-af77-57c1ce917d06",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e8f58-04a2-743c-a6a8-b0cd9c2f923d.webp",
      "image_media": {
        "alt_text": "Living room interior with carpet and a pass-through window to the kitchen.",
        "public_id": "019e8f58-04a2-743c-a6a8-b0cd9c2f923d",
        "storage_key": "property/6767906449167512/019e8f58-04a2-743c-a6a8-b0cd9c2f923d.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Spacious living room featuring neutral carpeting and a convenient pass-through window offering a glimpse into the kitchen area. Perfect for modern living.",
      "link": "",
      "alt_text": "Living room interior with carpet and a pass-through window to the kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_de4353f0-d9ae-4255-9341-f59b433bf44d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e8f58-0481-7758-8244-23da48738163.webp",
      "image_media": {
        "alt_text": "Closet with sliding doors in an empty room.",
        "public_id": "019e8f58-0481-7758-8244-23da48738163",
        "storage_key": "property/6767906449167512/019e8f58-0481-7758-8244-23da48738163.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "This image shows a closet with sliding doors in an empty room with carpet. The room appears to be part of an apartment unit.",
      "link": "",
      "alt_text": "Closet with sliding doors in an empty room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2db04d08-567a-4a7c-b767-bb9999f19931",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e8f58-048e-73b5-9ff7-bde05f3eac66.webp",
      "image_media": {
        "alt_text": "Interior view of a vacant apartment unit showing living room, kitchen pass-through, and hallway.",
        "public_id": "019e8f58-048e-73b5-9ff7-bde05f3eac66",
        "storage_key": "property/6767906449167512/019e8f58-048e-73b5-9ff7-bde05f3eac66.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Step into a spacious apartment featuring a pass-through to the kitchen and an open living area. Neutral tones and ample space make this unit your perfect canvas.",
      "link": "",
      "alt_text": "Interior view of a vacant apartment unit showing living room, kitchen pass-through, and hallway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3f11b230-0aae-465f-a7f4-80f1712d9868",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e8f57-f150-70a7-be5b-f9096f3fefb9.webp",
      "image_media": {
        "alt_text": "Empty apartment bedroom with neutral carpet and white walls.",
        "public_id": "019e8f57-f150-70a7-be5b-f9096f3fefb9",
        "storage_key": "property/6767906449167512/019e8f57-f150-70a7-be5b-f9096f3fefb9.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "A bright and airy empty bedroom in an apartment, featuring neutral carpeting and clean white walls, ready for your personal touch.",
      "link": "",
      "alt_text": "Empty apartment bedroom with neutral carpet and white walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d9c33a94-850b-4cec-ba99-67637abfe963",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019f054c-2fed-772e-9eb5-03bf2d4944cf.webp",
      "image_media": {
        "alt_text": "Woman relaxing on a couch while looking at her phone.",
        "public_id": "019f054c-2fed-772e-9eb5-03bf2d4944cf",
        "storage_key": "property/6767906449167512/019f054c-2fed-772e-9eb5-03bf2d4944cf.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Lifestyle",
      "description": "Enjoy your downtime in a comfortable living space, staying connected with loved ones or catching up on your favorite shows.",
      "link": "",
      "alt_text": "Woman relaxing on a couch while looking at her phone.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_62d94a9d-96a0-42b1-825b-100ea0fdab37",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e8f57-ed8c-7575-aee6-ba249e09e4f5.webp",
      "image_media": {
        "alt_text": "Interior view of an empty apartment bedroom with carpet and a large window.",
        "public_id": "019e8f57-ed8c-7575-aee6-ba249e09e4f5",
        "storage_key": "property/6767906449167512/019e8f57-ed8c-7575-aee6-ba249e09e4f5.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Spacious apartment bedroom featuring plush carpeting and a large window that floods the room with natural light. Ready for your personal touch.",
      "link": "",
      "alt_text": "Interior view of an empty apartment bedroom with carpet and a large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_570b3e3b-a272-441d-9ebd-8fb37ff76a18",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e8f57-ecfd-770e-82e9-7020810fe505.webp",
      "image_media": {
        "alt_text": "Interior of an empty apartment unit with hardwood floors and a ceiling fan.",
        "public_id": "019e8f57-ecfd-770e-82e9-7020810fe505",
        "storage_key": "property/6767906449167512/019e8f57-ecfd-770e-82e9-7020810fe505.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Experience the spaciousness of this apartment's living area, featuring a ceiling fan and ample wall space.",
      "link": "",
      "alt_text": "Interior of an empty apartment unit with hardwood floors and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_30949d93-2fb0-4201-a56b-c9a708d89084",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e8f57-ec3e-705d-962e-0448ed53d484.webp",
      "image_media": {
        "alt_text": "Kitchen area with white cabinets, a white oven, and a refrigerator.",
        "public_id": "019e8f57-ec3e-705d-962e-0448ed53d484",
        "storage_key": "property/6767906449167512/019e8f57-ec3e-705d-962e-0448ed53d484.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "This kitchen features white cabinetry and a full-size oven, providing a functional space for cooking.",
      "link": "",
      "alt_text": "Kitchen area with white cabinets, a white oven, and a refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_090e9164-ff71-41ce-b838-8a0fa121c717",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e8f57-e9f9-71d7-9221-71ebe196a6b3.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a window and a wooden door.",
        "public_id": "019e8f57-e9f9-71d7-9221-71ebe196a6b3",
        "storage_key": "property/6767906449167512/019e8f57-e9f9-71d7-9221-71ebe196a6b3.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "A view of an unfurnished bedroom featuring a large window that lets in ample natural light and a closed wooden door.",
      "link": "",
      "alt_text": "Empty bedroom with a window and a wooden door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b9f9af35-5f60-481a-924d-11d2fcb4b17c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019f054c-1d48-7510-90f4-7d315d2e7126.webp",
      "image_media": {
        "alt_text": "A man gently petting a cute tabby kitten, looking at each other warmly by a window.",
        "public_id": "019f054c-1d48-7510-90f4-7d315d2e7126",
        "storage_key": "property/6767906449167512/019f054c-1d48-7510-90f4-7d315d2e7126.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "Experience pet-friendly living and create cherished memories with your furry companions in our welcoming community, designed for both you and your pets.",
      "link": "",
      "alt_text": "A man gently petting a cute tabby kitten, looking at each other warmly by a window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a41b25fd-ee46-4d5c-b485-df44578d7143",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019f054c-3686-7023-919a-e63737528248.webp",
      "image_media": {
        "alt_text": "A smiling man with a beard holds a coffee mug, looking content in a bright, modern living room.",
        "public_id": "019f054c-3686-7023-919a-e63737528248",
        "storage_key": "property/6767906449167512/019f054c-3686-7023-919a-e63737528248.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "Start your day with a smile and a warm drink in the comfort of your home. Our residences provide a relaxed atmosphere perfect for unwinding and enjoying everyday moments.",
      "link": "",
      "alt_text": "A smiling man with a beard holds a coffee mug, looking content in a bright, modern living room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_05a2e5cf-f69f-43ac-b899-41a88c620829",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019f054c-385d-754e-9bb0-3f368de47d3d.webp",
      "image_media": {
        "alt_text": "Two diverse young women laughing together while looking at a smartphone.",
        "public_id": "019f054c-385d-754e-9bb0-3f368de47d3d",
        "storage_key": "property/6767906449167512/019f054c-385d-754e-9bb0-3f368de47d3d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Lifestyle",
      "description": "Experience the vibrant lifestyle of our community, where connection and shared moments thrive. Perfect for young professionals and friends.",
      "link": "",
      "alt_text": "Two diverse young women laughing together while looking at a smartphone.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_270a93a8-f462-4cb7-9288-5d308fd914f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019f054c-30f4-7111-af87-51528af8dd3b.webp",
      "image_media": {
        "alt_text": "A couple looks at a smartphone together, with a laptop and notepad on the table.",
        "public_id": "019f054c-30f4-7111-af87-51528af8dd3b",
        "storage_key": "property/6767906449167512/019f054c-30f4-7111-af87-51528af8dd3b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "A couple reviews information on a smartphone, suggesting they are planning or managing their living situation. The scene conveys a sense of collaboration and modern living.",
      "link": "",
      "alt_text": "A couple looks at a smartphone together, with a laptop and notepad on the table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_b7318bd5-0537-4653-8442-9099f5e903e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "Culver’s",
      "poi_type": "Restaurants",
      "poi_address": "2575 W Michigan St, Sidney, OH 45365, USA",
      "poi_short_description": "Fast-food chain specializing in frozen custard & signature burgers made with Midwest beef & dairy.",
      "poi_long_description": "People say this fast food restaurant offers delicious butter burgers, cheese curds, and creamy ice cream, with many highlighting the variety of menu options. They also mention the consistently clean dining areas and speedy service. Guests appreciate the friendly and helpful staff, noting their positive attitudes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e1-ec35-72cd-9e0d-94f629ef3e6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e1-ec35-72cd-9e0d-94f629ef3e6e",
        "storage_key": "property/6767906449167512/019e46e1-ec35-72cd-9e0d-94f629ef3e6e.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "http://www.culvers.com/restaurants/sidney/?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=14401550902756769308&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "culvers",
      "poi_latitude": "40.2873578",
      "poi_longitude": "-84.1947323",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 937-493-0015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0e87-7510-b96e-223ab2a6aed0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0e87-7510-b96e-223ab2a6aed0",
        "storage_key": "property/6767906449167512/019e46e2-0e87-7510-b96e-223ab2a6aed0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiQx2v9cIP4gRHP6FTT6W3Mc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_831fab51-406d-4550-a48b-d54592ab54ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "1975 W Michigan St, Sidney, OH 45365, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "People say this restaurant offers delicious food, including chicken tacos and quesadillas, with fresh ingredients and vegetarian options. They also highlight the fast service, clean dining areas, and friendly staff.\n\nSome reviews mention that the restaurant can be out of certain food items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e1-eb0a-70e8-b82d-0fe2110ee5c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e1-eb0a-70e8-b82d-0fe2110ee5c9",
        "storage_key": "property/6767906449167512/019e46e1-eb0a-70e8-b82d-0fe2110ee5c9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.chipotle.com/oh/sidney/1975-michigan-st?utm_source=google&utm_medium=yext&utm_campaign=yext_listings?restaurant=2777",
      "poi_directions_map_url": "https://maps.google.com/?cid=4517343173440950801&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "40.2871388",
      "poi_longitude": "-84.1844741",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 937-497-0057",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0e87-7510-b96e-223ab2a6aed0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0e87-7510-b96e-223ab2a6aed0",
        "storage_key": "property/6767906449167512/019e46e2-0e87-7510-b96e-223ab2a6aed0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJoSV3_SoPP4gREdJ7ra7TsD4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_b0d4628b-be8c-4c3d-ace3-3fee2293bab7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "The Spot Restaurant - Sidney, OH",
      "poi_type": "Restaurants",
      "poi_address": "201 S Ohio Ave, Sidney, OH 45365, USA",
      "poi_short_description": "Storied American counter-serve eatery known for breakfast, burgers & cream pies in throwback digs.",
      "poi_long_description": "People say this restaurant serves delicious burgers, malts, and pies. They also highlight the nostalgic, old-fashioned diner vibe and the friendly staff.\n\nOther reviews mention the onion rings can be greasy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e1-e988-748a-bdb5-ae993fba6497.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e1-e988-748a-bdb5-ae993fba6497",
        "storage_key": "property/6767906449167512/019e46e1-e988-748a-bdb5-ae993fba6497.webp",
        "width": 500,
        "height": 371
      },
      "poi_business_url": "http://thespottoeat.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2091455625238836502&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-spot-restaurant---sidney-oh",
      "poi_latitude": "40.284235",
      "poi_longitude": "-84.156919",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 937-492-9181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0e87-7510-b96e-223ab2a6aed0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0e87-7510-b96e-223ab2a6aed0",
        "storage_key": "property/6767906449167512/019e46e2-0e87-7510-b96e-223ab2a6aed0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8W6YeB0PP4gRFnXaZc9XBh0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_41d06495-20c2-49d9-afe0-3ef859ef2966",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "Murphy’s Craft Bar + Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "110 E Poplar St, Sidney, OH 45365, USA",
      "poi_short_description": "Cozy, kid-friendly eatery specializing in burgers, draft beer and cocktails.",
      "poi_long_description": "Guests consistently praise this restaurant for its delicious and flavorful food and extensive beer selection. They also appreciate the relaxing atmosphere and the friendly, attentive service provided.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e1-eca7-7337-bd63-711d283a1385.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e1-eca7-7337-bd63-711d283a1385",
        "storage_key": "property/6767906449167512/019e46e1-eca7-7337-bd63-711d283a1385.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://murphyscraftbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2732545614366253109&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "murphys-craft-bar--kitchen",
      "poi_latitude": "40.2858923",
      "poi_longitude": "-84.1560743",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 937-658-6160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0e87-7510-b96e-223ab2a6aed0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0e87-7510-b96e-223ab2a6aed0",
        "storage_key": "property/6767906449167512/019e46e2-0e87-7510-b96e-223ab2a6aed0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ0em1PIPP4gRNSDaNMLz6yU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_8838ab92-b545-48b0-8805-bcb566345e90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "Frisch's Big Boy",
      "poi_type": "Restaurants",
      "poi_address": "2120 W Michigan St, Sidney, OH 45365, USA",
      "poi_short_description": "Chain restaurant offering burgers & other American standards, plus drive-thru service.",
      "poi_long_description": "People say this diner offers a breakfast bar with fresh food. They also highlight the fast service and friendly staff.\n\nOther reviews mention the food can be poorly prepared.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e1-ea3a-75dc-a05f-048a5557d853.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e1-ea3a-75dc-a05f-048a5557d853",
        "storage_key": "property/6767906449167512/019e46e1-ea3a-75dc-a05f-048a5557d853.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://locations.frischs.com/frischs-big-boy-97eec32185af?utm_source=google-my-business&utm_medium=listings&utm_campaign=gmb&utm_content=2120-west-michigan-street",
      "poi_directions_map_url": "https://maps.google.com/?cid=17402228767917028932&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "frischs-big-boy",
      "poi_latitude": "40.288147",
      "poi_longitude": "-84.1874136",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 937-492-0321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0e87-7510-b96e-223ab2a6aed0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0e87-7510-b96e-223ab2a6aed0",
        "storage_key": "property/6767906449167512/019e46e2-0e87-7510-b96e-223ab2a6aed0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSRU14CoPP4gRRDbHC90igfE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_d78b1bad-77f4-4be4-a921-20cc3f0a6667",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "Menards",
      "poi_type": "Shopping & Retail",
      "poi_address": "401 Lester Ave, Sidney, OH 45365, USA",
      "poi_short_description": "Home improvement chain with assorted building materials, tools, gardening supplies & appliances.",
      "poi_long_description": "Customers consistently praise this store for its extensive selection of house and yard items, alongside a limited grocery section, and appreciate the availability of secure and inexpensive storage units. Furthermore, reviewers highlight the excellent service and hassle-free returns process.\n\nSome reviews mention the staff can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e1-ea10-718f-afc4-ccb23554d699.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e1-ea10-718f-afc4-ccb23554d699",
        "storage_key": "property/6767906449167512/019e46e1-ea10-718f-afc4-ccb23554d699.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.menards.com/store-details/store.html?store=3216&utm_source=localcard&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=13664846038512860213&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "menards",
      "poi_latitude": "40.2896273",
      "poi_longitude": "-84.20307989999999",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 937-492-6243",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0e74-77a3-b576-f3918cc079b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0e74-77a3-b576-f3918cc079b8",
        "storage_key": "property/6767906449167512/019e46e2-0e74-77a3-b576-f3918cc079b8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJr07IMtkIP4gRNXz2kxJJo70",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_def9c4db-4ff8-4c18-a6ed-a37186657ad8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "2700 W Michigan St, Sidney, OH 45365, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e1-e97a-7207-b3e1-3c88cd1bd3ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e1-e97a-7207-b3e1-3c88cd1bd3ab",
        "storage_key": "property/6767906449167512/019e46e1-e97a-7207-b3e1-3c88cd1bd3ab.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OH-Sidney/2511?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-2511-_-na-_-0-_-0&y_source=1_MTE4NDQ1OC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13754839017727890490&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "40.289749",
      "poi_longitude": "-84.205924",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 937-498-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0e74-77a3-b576-f3918cc079b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0e74-77a3-b576-f3918cc079b8",
        "storage_key": "property/6767906449167512/019e46e2-0e74-77a3-b576-f3918cc079b8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJs3hPOt4IP4gROpRa2jUB474",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_a69033e2-332d-421f-8b2b-2f37ee2d3200",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "2500 W Michigan St, Sidney, OH 45365, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e1-eee0-7200-8812-fc9e6484fd36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e1-eee0-7200-8812-fc9e6484fd36",
        "storage_key": "property/6767906449167512/019e46e1-eee0-7200-8812-fc9e6484fd36.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://info.aldi.us/stores/l/oh/sidney/2500-michigan-st/f526",
      "poi_directions_map_url": "https://maps.google.com/?cid=9069956546411225685&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "40.28828",
      "poi_longitude": "-84.19318",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0ea4-7195-8747-36f997d766dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0ea4-7195-8747-36f997d766dd",
        "storage_key": "property/6767906449167512/019e46e2-0ea4-7195-8747-36f997d766dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-4YQdykPP4gRVeIRnWz13n0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_590559d9-9fd0-4fb3-b9d5-4d20a634b0c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "bealls",
      "poi_type": "Shopping & Retail",
      "poi_address": "2290 W Michigan St, Sidney, OH 45365, USA",
      "poi_short_description": "Department store stocking home goods & an assortment of apparel, shoes & accessories for all ages.",
      "poi_long_description": "Department store stocking home goods & an assortment of apparel, shoes & accessories for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e1-eb15-7279-ae69-340f03e94828.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e1-eb15-7279-ae69-340f03e94828",
        "storage_key": "property/6767906449167512/019e46e1-eb15-7279-ae69-340f03e94828.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "https://stores.bealls.com/oh/sidney/2290-w-michigan-street",
      "poi_directions_map_url": "https://maps.google.com/?cid=1870329967049580925&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bealls",
      "poi_latitude": "40.2901191",
      "poi_longitude": "-84.19032510000001",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 937-498-0035",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0e74-77a3-b576-f3918cc079b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0e74-77a3-b576-f3918cc079b8",
        "storage_key": "property/6767906449167512/019e46e2-0e74-77a3-b576-f3918cc079b8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJx7GCmZcJP4gRfSHCEjK_9Bk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_774c0048-bf2b-4f92-9dad-6c6b0945508b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "Sidney Foodtown",
      "poi_type": "Shopping & Retail",
      "poi_address": "1010 Wapakoneta Ave, Sidney, OH 45365, USA",
      "poi_short_description": "Casual, locally owned grocery store that features a deli with homemade items and bulk candy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e1-eea2-72bc-a218-83814a31c4d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e1-eea2-72bc-a218-83814a31c4d5",
        "storage_key": "property/6767906449167512/019e46e1-eea2-72bc-a218-83814a31c4d5.webp",
        "width": 622,
        "height": 1280
      },
      "poi_business_url": "https://www.foodtownsidneyoh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9047420081788119687&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sidney-foodtown",
      "poi_latitude": "40.29709709999999",
      "poi_longitude": "-84.1571062",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 937-492-3121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0ea4-7195-8747-36f997d766dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0ea4-7195-8747-36f997d766dd",
        "storage_key": "property/6767906449167512/019e46e2-0ea4-7195-8747-36f997d766dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi3o_HxEPP4gRh2q3DKHkjn0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_41f1b99c-600d-4d7a-8b89-e96af6dc643a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "Amos Memorial Public Library",
      "poi_type": "Education",
      "poi_address": "230 E North St, Sidney, OH 45365, USA",
      "poi_short_description": "Clean library with books and computers and friendly staff, plus study areas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e1-f0f6-72cf-bfb7-51e74d00823a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e1-f0f6-72cf-bfb7-51e74d00823a",
        "storage_key": "property/6767906449167512/019e46e1-f0f6-72cf-bfb7-51e74d00823a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://shelbycountylibraries.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17677857174801448410&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amos-memorial-public-library",
      "poi_latitude": "40.2871288",
      "poi_longitude": "-84.1539866",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 937-492-8354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0ea9-70bb-b9f9-e7403aad768d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0ea9-70bb-b9f9-e7403aad768d",
        "storage_key": "property/6767906449167512/019e46e2-0ea9-70bb-b9f9-e7403aad768d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJNflK0hwPP4gR2n0hbnBdVPU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_e19550f6-3376-48b3-9881-743b22a35315",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "Sidney Memorial Stadium",
      "poi_type": "Entertainment",
      "poi_address": "750 S 4th Ave, Sidney, OH 45365, USA",
      "poi_short_description": "Stadium for high school games that's also good for kids.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e1-f15e-7329-a57f-6c6b2f787040.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e1-f15e-7329-a57f-6c6b2f787040",
        "storage_key": "property/6767906449167512/019e46e1-f15e-7329-a57f-6c6b2f787040.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://ohiostadiums.com/stadium.php?id=1474",
      "poi_directions_map_url": "https://maps.google.com/?cid=6741007723494088034&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sidney-memorial-stadium",
      "poi_latitude": "40.2778431",
      "poi_longitude": "-84.17715489999999",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0e98-7238-ace0-6ac31fc31489.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0e98-7238-ace0-6ac31fc31489",
        "storage_key": "property/6767906449167512/019e46e2-0e98-7238-ace0-6ac31fc31489.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmSuFnucPP4gRYp0HI8_ejF0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_ff4ea4fe-614c-4a6b-9f86-b77b8a814f9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "Shelby County Historical Society",
      "poi_type": "Entertainment",
      "poi_address": "201 N Main Ave, Sidney, OH 45365, USA",
      "poi_short_description": "Free museum featuring exhibits on local history alongside friendly staff and guided tours.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e1-f459-74ae-ab6f-0d8829439b56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e1-f459-74ae-ab6f-0d8829439b56",
        "storage_key": "property/6767906449167512/019e46e1-f459-74ae-ab6f-0d8829439b56.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "https://www.shelbycountyhistory.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11769570378662980825&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "shelby-county-historical-society",
      "poi_latitude": "40.2870668",
      "poi_longitude": "-84.15541189999999",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 937-498-1653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0e95-70d6-98ca-f4a5464f4c7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0e95-70d6-98ca-f4a5464f4c7a",
        "storage_key": "property/6767906449167512/019e46e2-0e95-70d6-98ca-f4a5464f4c7a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJQa1u3BwPP4gR2awqy-bpVaM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_2f77773e-b8d5-4e62-8d54-5097998f1325",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "Historic Ross Covered Bridge",
      "poi_type": "Entertainment",
      "poi_address": "12 Tawawa Dr, Sidney, OH 45365, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e1-f269-7084-8754-6c3cc9ed680b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e1-f269-7084-8754-6c3cc9ed680b",
        "storage_key": "property/6767906449167512/019e46e1-f269-7084-8754-6c3cc9ed680b.webp",
        "width": 1280,
        "height": 1059
      },
      "poi_business_url": "https://www.sidneyoh.com/facilities/facility/details/Ross-Bridge-53",
      "poi_directions_map_url": "https://maps.google.com/?cid=13097465102645209843&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "historic-ross-covered-bridge",
      "poi_latitude": "40.2897372",
      "poi_longitude": "-84.1322998",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 937-498-2335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0e73-719a-a216-6f45c5954117.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0e73-719a-a216-6f45c5954117",
        "storage_key": "property/6767906449167512/019e46e2-0e73-719a-a216-6f45c5954117.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaaOuJ64PP4gR8yo-FR6Lw7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_d6911309-d6a7-4518-b1eb-63424adea000",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "Flinn Veterinary Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "2240 Wapakoneta Ave, Sidney, OH 45365, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e1-f27d-7606-8a1a-bcd33a06e09e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e1-f27d-7606-8a1a-bcd33a06e09e",
        "storage_key": "property/6767906449167512/019e46e1-f27d-7606-8a1a-bcd33a06e09e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://flinnvet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1425562174830176769&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "flinn-veterinary-clinic",
      "poi_latitude": "40.310808",
      "poi_longitude": "-84.15987799999999",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 937-492-3422",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0e73-719a-a216-6f45c5954117.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0e73-719a-a216-6f45c5954117",
        "storage_key": "property/6767906449167512/019e46e2-0e73-719a-a216-6f45c5954117.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj_s642sPP4gRAWr8uz6dyBM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_68f4ff94-cee5-40e5-8c5d-ee10f575a782",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "JC's Barbershop",
      "poi_type": "Health and Wellness",
      "poi_address": "1282 Wapakoneta Ave, Sidney, OH 45365, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e1-f5a6-77a5-816f-38454b36d5e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e1-f5a6-77a5-816f-38454b36d5e5",
        "storage_key": "property/6767906449167512/019e46e1-f5a6-77a5-816f-38454b36d5e5.webp",
        "width": 1242,
        "height": 813
      },
      "poi_business_url": "https://biryo.top/jc-s-barbershop-jl9zeae",
      "poi_directions_map_url": "https://maps.google.com/?cid=76688460194915907&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jcs-barbershop",
      "poi_latitude": "40.30143169999999",
      "poi_longitude": "-84.1584027",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 937-489-8067",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0e73-719a-a216-6f45c5954117.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0e73-719a-a216-6f45c5954117",
        "storage_key": "property/6767906449167512/019e46e2-0e73-719a-a216-6f45c5954117.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAxBmZxcPP4gRQyZKjL9zEAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_942e4865-391a-4bda-ac2c-54e72576f02d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "Community Veterinary Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "1200 W Russell Rd, Sidney, OH 45365, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e1-f608-7083-8c52-03ce96803cf0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e1-f608-7083-8c52-03ce96803cf0",
        "storage_key": "property/6767906449167512/019e46e1-f608-7083-8c52-03ce96803cf0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://mycommunityveterinaryclinic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3563613120829701273&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "community-veterinary-clinic",
      "poi_latitude": "40.3022646",
      "poi_longitude": "-84.1785086",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 937-492-6106",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0e73-719a-a216-6f45c5954117.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0e73-719a-a216-6f45c5954117",
        "storage_key": "property/6767906449167512/019e46e2-0e73-719a-a216-6f45c5954117.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv4pTsDkPP4gRmbz5p0B_dDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_d0692bbf-cc45-4e77-8f8d-d230795e89e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "The Hair Company & Day Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "410 W Russell Rd, Sidney, OH 45365, USA",
      "poi_short_description": "Family-owned salon for cuts, hair color, styling, manicures and pedicures. Friendly staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e1-f905-7695-9c60-98fba47bb22a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e1-f905-7695-9c60-98fba47bb22a",
        "storage_key": "property/6767906449167512/019e46e1-f905-7695-9c60-98fba47bb22a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7248109403098440017&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-hair-company--day-spa",
      "poi_latitude": "40.30267500000001",
      "poi_longitude": "-84.162578",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 937-492-7666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0e73-719a-a216-6f45c5954117.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0e73-719a-a216-6f45c5954117",
        "storage_key": "property/6767906449167512/019e46e2-0e73-719a-a216-6f45c5954117.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV-fPBhUPP4gRUeHZmBl1lmQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_da516cdb-5640-47a4-b8cb-d3e77f08b96b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "Ellie Nails & Spa (Sidney, Ohio)",
      "poi_type": "Health and Wellness",
      "poi_address": "2040 W Michigan St, Sidney, OH 45365, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e1-fada-7078-a017-29bda30744c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e1-fada-7078-a017-29bda30744c0",
        "storage_key": "property/6767906449167512/019e46e1-fada-7078-a017-29bda30744c0.webp",
        "width": 591,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/Ellie-nails-spa-103506115231429/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15764079846423892330&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ellie-nails--spa-sidney-ohio",
      "poi_latitude": "40.2895565",
      "poi_longitude": "-84.186247",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 937-710-4250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0e73-719a-a216-6f45c5954117.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0e73-719a-a216-6f45c5954117",
        "storage_key": "property/6767906449167512/019e46e2-0e73-719a-a216-6f45c5954117.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJURPFDg0JP4gRapH9QBlDxdo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_cab2d0ac-2777-441f-b8f6-34ef65bb41fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "Tri-County Veterinary Service",
      "poi_type": "Health and Wellness",
      "poi_address": "3714 W Michigan St, Sidney, OH 45365, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e1-f8c5-710a-b080-fdbedb8dfd95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e1-f8c5-710a-b080-fdbedb8dfd95",
        "storage_key": "property/6767906449167512/019e46e1-f8c5-710a-b080-fdbedb8dfd95.webp",
        "width": 832,
        "height": 938
      },
      "poi_business_url": "http://www.tricountyvetservice.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1698561224398566330&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tri-county-veterinary-service",
      "poi_latitude": "40.2874984",
      "poi_longitude": "-84.22427359999999",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 937-492-6536",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0e73-719a-a216-6f45c5954117.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0e73-719a-a216-6f45c5954117",
        "storage_key": "property/6767906449167512/019e46e2-0e73-719a-a216-6f45c5954117.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHxLZbuAIP4gRunOHKW-Akhc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_4ae4e64e-3b89-452b-bbba-5c7dfbbf66fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "2170 W Michigan St, Sidney, OH 45365, USA",
      "poi_short_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e1-f96a-778f-aadd-5d63514dbfb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e1-f96a-778f-aadd-5d63514dbfb0",
        "storage_key": "property/6767906449167512/019e46e1-f96a-778f-aadd-5d63514dbfb0.webp",
        "width": 680,
        "height": 383
      },
      "poi_business_url": "https://salons.greatclips.com/us/oh/sidney/2170-w-michigan-ave?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=15579584426275155688&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "40.2895843",
      "poi_longitude": "-84.1872078",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 937-498-4247",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0e73-719a-a216-6f45c5954117.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0e73-719a-a216-6f45c5954117",
        "storage_key": "property/6767906449167512/019e46e2-0e73-719a-a216-6f45c5954117.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJaW_3yoPP4gR6K5W1H3NNdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_e07d3d19-45e0-4a6b-8206-e122acfcd7b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "Expo Nails",
      "poi_type": "Health and Wellness",
      "poi_address": "400 N Vandemark Rd, Sidney, OH 45365, USA",
      "poi_short_description": "Visitors can get nail and foot care services at this salon in the Sidney Towne Center.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e1-fbe2-70ab-878e-2a316703de04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e1-fbe2-70ab-878e-2a316703de04",
        "storage_key": "property/6767906449167512/019e46e1-fbe2-70ab-878e-2a316703de04.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6228306209598722144&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "expo-nails",
      "poi_latitude": "40.2897958",
      "poi_longitude": "-84.1873969",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 937-497-1575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0e73-719a-a216-6f45c5954117.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0e73-719a-a216-6f45c5954117",
        "storage_key": "property/6767906449167512/019e46e2-0e73-719a-a216-6f45c5954117.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNYZ7A9UIP4gRYNB9p39jb1Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_431b0e54-ed2c-42ee-bdda-4dc20d080fbb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "Downtown Barbershop",
      "poi_type": "Health and Wellness",
      "poi_address": "113 E Court St, Sidney, OH 45365, USA",
      "poi_short_description": "Family-friendly barbershop with friendly staff offering haircuts for all ages in a casual environment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e1-face-710c-947b-3bb0026c7d5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e1-face-710c-947b-3bb0026c7d5a",
        "storage_key": "property/6767906449167512/019e46e1-face-710c-947b-3bb0026c7d5a.webp",
        "width": 335,
        "height": 500
      },
      "poi_business_url": "http://downtownbarbershop71.booksy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8529554653885155026&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "downtown-barbershop",
      "poi_latitude": "40.2841412",
      "poi_longitude": "-84.1562371",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 937-498-7467",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0e73-719a-a216-6f45c5954117.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0e73-719a-a216-6f45c5954117",
        "storage_key": "property/6767906449167512/019e46e2-0e73-719a-a216-6f45c5954117.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ32VeB0PP4gR0sYaJcQQX3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_36e5434e-0687-4b89-9fff-55104cd89267",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "B Squared Hair Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "1500 N Main Ave, Sidney, OH 45365, USA",
      "poi_short_description": "Salon known for haircuts, coloring, manicures and pedicures, plus styling services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e1-fcf1-74bb-8c35-084c69221efe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e1-fcf1-74bb-8c35-084c69221efe",
        "storage_key": "property/6767906449167512/019e46e1-fcf1-74bb-8c35-084c69221efe.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://bsquaredhairstudio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17414973638045333101&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "b-squared-hair-studio",
      "poi_latitude": "40.3025656",
      "poi_longitude": "-84.15485679999999",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 937-538-9176",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0e73-719a-a216-6f45c5954117.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0e73-719a-a216-6f45c5954117",
        "storage_key": "property/6767906449167512/019e46e2-0e73-719a-a216-6f45c5954117.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfYnPhOUPP4gRbfZ7XEFqrvE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_6fe2b112-778c-4c94-96d0-51e8b79b83e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "Wilson Health",
      "poi_type": "Health and Wellness",
      "poi_address": "915 Michigan St, Sidney, OH 45365, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e1-fcaf-7308-a7a9-6509b76d5f88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e1-fcaf-7308-a7a9-6509b76d5f88",
        "storage_key": "property/6767906449167512/019e46e1-fcaf-7308-a7a9-6509b76d5f88.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wilsonhealth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6295323183174597155&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wilson-health",
      "poi_latitude": "40.2869724",
      "poi_longitude": "-84.17041429999999",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 937-498-2311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0e71-7392-ae12-cc51cc57a842.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0e71-7392-ae12-cc51cc57a842",
        "storage_key": "property/6767906449167512/019e46e2-0e71-7392-ae12-cc51cc57a842.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJnyJ8tqQPP4gRIzpnvxR7XVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e4e0061b-41b4-47fd-a7da-f7d4b125ea59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "Tawawa Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12 Tawawa Dr, Sidney, OH 45365, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this park offers numerous playgrounds for children, extensive walking trails, and a large lake for fishing. Visitors also highlight the beautiful scenery and convenient picnic areas with grills and nearby portable restrooms. They also mention the park is excellent for finding peace and enjoying outdoor activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e1-fb62-730f-a61d-95be638fd4d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e1-fb62-730f-a61d-95be638fd4d6",
        "storage_key": "property/6767906449167512/019e46e1-fb62-730f-a61d-95be638fd4d6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sidneyoh.com/Facilities/Facility/Details/Tawawa-Park-24",
      "poi_directions_map_url": "https://maps.google.com/?cid=6844262949671679020&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tawawa-park",
      "poi_latitude": "40.2897533",
      "poi_longitude": "-84.13269249999999",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 937-498-2335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0e72-75d6-b7f4-81360aa706a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0e72-75d6-b7f4-81360aa706a9",
        "storage_key": "property/6767906449167512/019e46e2-0e72-75d6-b7f4-81360aa706a9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9cwBM64PP4gRLDSM6OO0-14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7ef7a412-a254-43f1-aef2-487fb9e89754",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "Custenborder Field",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "22 10-276-001, Sidney, OH 45365, USA",
      "poi_short_description": "Sprawling park featuring baseball and softball fields, plus a playground and shelter houses.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0086-7660-a20e-6c5d9a978040.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-0086-7660-a20e-6c5d9a978040",
        "storage_key": "property/6767906449167512/019e46e2-0086-7660-a20e-6c5d9a978040.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14680454337824726962&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "custenborder-field",
      "poi_latitude": "40.2905523",
      "poi_longitude": "-84.1466263",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0e72-75d6-b7f4-81360aa706a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0e72-75d6-b7f4-81360aa706a9",
        "storage_key": "property/6767906449167512/019e46e2-0e72-75d6-b7f4-81360aa706a9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQzq4RcPP4gRsp9im3Bzu8s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0332f9f1-79d3-40ba-87d1-a6a7c094b611",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "Moose Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1200 Broadway Ave, Sidney, OH 45365, USA",
      "poi_short_description": "Quirky 9-hole golf course featuring 4 sets of tees, plus food and drinks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0095-771a-b884-bd3139aedde3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-0095-771a-b884-bd3139aedde3",
        "storage_key": "property/6767906449167512/019e46e2-0095-771a-b884-bd3139aedde3.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "http://sidneymoose.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9440310000368175154&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "moose-golf-course",
      "poi_latitude": "40.3",
      "poi_longitude": "-84.14833329999999",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 937-492-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0ea0-7129-8955-52ac3c127a89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0ea0-7129-8955-52ac3c127a89",
        "storage_key": "property/6767906449167512/019e46e2-0ea0-7129-8955-52ac3c127a89.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5-kuPQwPP4gRMkiDre23AoM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_80a6a5b2-fb61-4520-9a5d-b1051b585bdc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "Canal Feeder Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Canal Feeder Trail, Sidney, OH 45365, USA",
      "poi_short_description": "Scenic site featuring a trail for walking and biking that leads to the Great Miami River.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-001c-749f-98bf-72e008a08473.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-001c-749f-98bf-72e008a08473",
        "storage_key": "property/6767906449167512/019e46e2-001c-749f-98bf-72e008a08473.webp",
        "width": 972,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13635304008405130068&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "canal-feeder-trail",
      "poi_latitude": "40.2641958",
      "poi_longitude": "-84.17478740000001",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0e72-75d6-b7f4-81360aa706a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0e72-75d6-b7f4-81360aa706a9",
        "storage_key": "property/6767906449167512/019e46e2-0e72-75d6-b7f4-81360aa706a9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJjxMdBLgOP4gRVJtyscBUOr0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d03a2cbf-2d38-47cf-bf90-0b13449805da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "Deam Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Deam Park, 301-399 Lunar St, Sidney, OH 45365, USA",
      "poi_short_description": "Park with a playground, a dog park, picnic tables, and facilities for basketball.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-01b7-70b6-bddb-0ce25319d253.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-01b7-70b6-bddb-0ce25319d253",
        "storage_key": "property/6767906449167512/019e46e2-01b7-70b6-bddb-0ce25319d253.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10126474450789767981&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "deam-park",
      "poi_latitude": "40.3102959",
      "poi_longitude": "-84.1531086",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0e72-75d6-b7f4-81360aa706a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0e72-75d6-b7f4-81360aa706a9",
        "storage_key": "property/6767906449167512/019e46e2-0e72-75d6-b7f4-81360aa706a9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ67Vl6XEPP4gRLZtkUtx2iIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4cac4022-40b9-4efe-a224-11f726213d71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "Sidney Municipal Airport- KSCA",
      "poi_type": "Transportation & Transit",
      "poi_address": "14833 Sidney-Plattsville Rd, Sidney, OH 45365, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0413-733c-b837-521253c31634.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-0413-733c-b837-521253c31634",
        "storage_key": "property/6767906449167512/019e46e2-0413-733c-b837-521253c31634.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18207158057481364355&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sidney-municipal-airport--ksca",
      "poi_latitude": "40.2366676",
      "poi_longitude": "-84.1528701",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 937-492-9794",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-10cc-7793-8623-d32123bd0108.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-10cc-7793-8623-d32123bd0108",
        "storage_key": "property/6767906449167512/019e46e2-10cc-7793-8623-d32123bd0108.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJp68WeSQMP4gRg2ORocnRrPw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_028b6281-112f-41f0-8070-e25269f9545c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "Advanced Composites",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1062 S 4th Ave #1084, Sidney, OH 45365, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-054a-7610-8bc5-0d0eba1c0308.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-054a-7610-8bc5-0d0eba1c0308",
        "storage_key": "property/6767906449167512/019e46e2-054a-7610-8bc5-0d0eba1c0308.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.advcmp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12210799407879265910&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "advanced-composites",
      "poi_latitude": "40.2721348",
      "poi_longitude": "-84.17777099999999",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 937-575-9800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0e73-719a-a216-6f45c5954117.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0e73-719a-a216-6f45c5954117",
        "storage_key": "property/6767906449167512/019e46e2-0e73-719a-a216-6f45c5954117.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA3Vvr88OP4gRdp4xql15dak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e1fcfa07-df67-48fa-9814-cdef343c6990",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "AAA Shelby County",
      "poi_type": "Major Employers & Offices",
      "poi_address": "930 Wapakoneta Ave, Sidney, OH 45365, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0591-742e-bd9f-df7f45cc9320.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-0591-742e-bd9f-df7f45cc9320",
        "storage_key": "property/6767906449167512/019e46e2-0591-742e-bd9f-df7f45cc9320.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://aaa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13032780990908959382&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "aaa-shelby-county",
      "poi_latitude": "40.2958412",
      "poi_longitude": "-84.1567535",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 937-492-3167",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0e73-719a-a216-6f45c5954117.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0e73-719a-a216-6f45c5954117",
        "storage_key": "property/6767906449167512/019e46e2-0e73-719a-a216-6f45c5954117.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkUJljBAPP4gRloqXtkK93bQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_15bb4476-0981-4fc3-a2f7-be5b358e8461",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "poi_name": "Bryce Realty LLC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2805 Wapakoneta Ave Suite 95, Sidney, OH 45365, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.brycerealtyllc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11560495353339439518&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bryce-realty-llc",
      "poi_latitude": "40.319594",
      "poi_longitude": "-84.1642184",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 937-538-4772",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167512/019e46e2-0e73-719a-a216-6f45c5954117.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e2-0e73-719a-a216-6f45c5954117",
        "storage_key": "property/6767906449167512/019e46e2-0e73-719a-a216-6f45c5954117.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy2ah3WAPP4gRnulZE0Yhb6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_042e708115096fd1ab5904d2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "day": "MON",
      "open_time": "08:00",
      "close_time": "16:00"
    },
    {
      "id": "ec_9b2ed5c95c4e6ea4d8cd6cca",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "day": "TUE",
      "open_time": "08:00",
      "close_time": "16:00"
    },
    {
      "id": "ec_b76b679787401a22a9f84c2c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "day": "WED",
      "open_time": "08:00",
      "close_time": "16:00"
    },
    {
      "id": "ec_803aa516dd2b6ed6d39e4044",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "day": "THU",
      "open_time": "08:00",
      "close_time": "16:00"
    },
    {
      "id": "ec_3151868466288a15ffca2e34",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "day": "FRI",
      "open_time": "08:00",
      "close_time": "16:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_67f96bc2b8899c2b4ec9f6ed",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "rating": "5",
      "name": "Kayla Mazingo",
      "text": "Alicia has been great to deal with throughout the application process. She was very helpful in getting my needs met on the move in date. When we walked through the apartment it was clean, and things seem to have been updated.",
      "date": "2025-03-05",
      "title": "false"
    },
    {
      "id": "ec_948633adfa47a3cdc5d565a4",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "rating": "5",
      "name": "Bri",
      "text": "I had the best experience with Alicia the manager. I came into the office to see if any apartments were available. She was very professional and kind when I was asking questions. She even went above and beyond to show me a unit that was open. The office is very warm welcoming. I would highly recommend reaching out to Alicia if you are in need of an apartment.",
      "date": "2024-08-06",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019ed0ea-cc97-743c-a841-bb706e6adaaf",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Sycamore Creek Apartments Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512"
    },
    {
      "lead_collector_id": "019ed0ea-cd23-74d6-9509-6bb6389d705c",
      "lead_source": "LANDING_PAGE",
      "name": "Sycamore Creek Apartments Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-sidney-oh-sycamore-creek",
      "search_query": "pet friendly apartments Sidney OH",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Sidney, OH",
      "h2_subtitle": "Discover pet-friendly living at Sycamore Creek. Our community in Sidney offers features that cater to both you and your furry friends.",
      "page_copy": "At Sycamore Creek, we understand that pets are family too. Our pet-friendly apartments in Sidney, OH, are designed to accommodate both you and your furry companions. With controlled access and a professional management team on-site, you can enjoy peace of mind while strolling with your pet around our community. Situated in a serene neighborhood, Sycamore Creek provides the ideal backdrop for pet-friendly living.\n\nOur amenities include laundry facilities in each building and high-speed internet access, making life easier and more enjoyable. Convenient emergency maintenance ensures that any issues are promptly addressed, further enhancing your living experience in our pet-friendly community. At Sycamore Creek, you and your pet can enjoy a cozy, welcoming home in beautiful Sidney, OH.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Sidney, OH",
      "seo_description": "Find pet-friendly apartments in Sidney, OH at Sycamore Creek. Enjoy amenities and a comfortable home for you and your pet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "page_item_url": "apartments-with-playground-sidney-sycamore-creek",
      "search_query": "apartments with playground Sidney",
      "category": "Amenity",
      "h1_title": "Apartments with Playground in Sidney",
      "h2_subtitle": "Experience pet-friendly living at Sycamore Creek. Enjoy our community amenities, including a playground for residents in Sidney.",
      "page_copy": "Sycamore Creek offers apartment homes with a community playground in Sidney. The playground provides an outdoor recreational amenity available for resident use within the community.\n\nCommunity features include laundry facilities in each building, high-speed internet access, professional on-site management, and emergency maintenance services. Sycamore Creek combines practical apartment amenities with recreational community features and convenient access to local amenities throughout Sidney.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Playground in Sidney",
      "seo_description": "Enjoy pet-friendly living at Sycamore Creek, featuring a community playground in Sidney. Ideal for anyone seeking convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "page_item_url": "high-speed-internet-access-apartments-shelby-county",
      "search_query": "high speed internet access apartments Shelby County",
      "category": "Amenity",
      "h1_title": "High-Speed Internet Apartments Shelby County",
      "h2_subtitle": "Stay connected at Sycamore Creek with high-speed internet access. Our apartments in Shelby County meet all your connectivity needs.",
      "page_copy": "For those needing seamless connectivity, Sycamore Creek Apartments in Shelby County offer high-speed internet access, ensuring you stay connected for work, play, or family. Whether you're streaming your favorite shows, working from home, or catching up on the latest news, our high-speed internet is reliable and fast, catering to modern tech demands.\n\nIn addition to high-speed internet access, Sycamore Creek provides a range of amenities tailored to enhance your living experience, such as controlled access and a professional management team on-site. Our laundry facilities in each building and emergency maintenance services ensure convenience and peace of mind, making our community in Sidney a smart choice for those who prioritize connectivity alongside comfort.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "High-Speed Internet Apartments Shelby County",
      "seo_description": "Sycamore Creek offers high-speed internet access in Shelby County, ensuring connectivity and comfort with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "page_item_url": "spacious-floor-plan-apartments-sidney-oh-sycamore-creek",
      "search_query": "spacious floor plan apartments Sidney OH",
      "category": "Amenity",
      "h1_title": "Spacious Floor Plan Apartments in Sidney, OH",
      "h2_subtitle": "Enjoy roomy living at Sycamore Creek. Our spacious floor plan apartments in Sidney, OH provide comfort and style.",
      "page_copy": "At Sycamore Creek, we understand the importance of space in a home. Our spacious floor plan apartments in Sidney, OH are designed to provide ample living areas that suit your lifestyle needs. Whether you're entertaining guests or enjoying a quiet evening, our floor plans offer versatility and comfort.\n\nLocated in scenic Sidney, our community includes amenities like high-speed internet access and laundry facilities in each building, making day-to-day tasks convenient. The controlled access and on-site professional management team ensure further peace of mind, allowing you to fully enjoy your spacious new home at Sycamore Creek.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Floor Plan Apartments in Sidney, OH",
      "seo_description": "Discover spacious floor plan apartments in Sidney, OH at Sycamore Creek, designed for comfort and convenience with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "page_item_url": "apartments-with-balcony-or-patio-sidney-oh-sycamore-creek",
      "search_query": "apartments with balcony or patio Sidney OH",
      "category": "Amenity",
      "h1_title": "Apartments with Balcony in Sidney, OH",
      "h2_subtitle": "Unwind outdoors at Sycamore Creek. Our Sidney, OH apartments feature balconies or patios for relaxation and enjoyment.",
      "page_copy": "Sycamore Creek Apartments offers a blend of indoor comfort and outdoor relaxation with our apartments that include a balcony or patio in Sidney, OH. These outdoor spaces provide the perfect backdrop for sipping morning coffee or unwinding after a long day while enjoying scenic views.\n\nLocated in the charming city of Sidney, Sycamore Creek is more than just a living space. Residents benefit from controlled access, high-speed internet, and on-site professional management, providing peace of mind and convenience. With additional amenities such as a laundry facility in each building, you’ll truly experience effortless living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Balcony in Sidney, OH",
      "seo_description": "Sycamore Creek offers apartments with balconies or patios in Sidney, OH. Enjoy outdoor living with modern amenities and scenic views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-sidney-oh-sycamore-creek",
      "search_query": "two bedroom apartments Sidney OH",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Sidney, OH",
      "h2_subtitle": "Discover spacious two-bedroom apartments at Sycamore Creek in Sidney, OH. Perfect for anyone seeking comfort and style.",
      "page_copy": "Explore two-bedroom apartments at Sycamore Creek in Sidney, OH. These floor plans provide additional living space, flexible layouts, and open interiors designed to support everyday apartment living.\n\nCommunity amenities include high-speed internet access, laundry facilities in each building, controlled access, and professional on-site management. Sycamore Creek combines practical apartment conveniences with modern community features in Sidney.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Sidney, OH",
      "seo_description": "Sycamore Creek offers spacious two-bedroom apartments in Sidney, OH. Enjoy modern living with convenient amenities in a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "page_item_url": "three-bedroom-floor-plans-shelby-county-sycamore-creek",
      "search_query": "three bedroom floorplans Shelby County",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Floor Plans in Shelby County",
      "h2_subtitle": "Explore spacious three-bedroom floor plans at Sycamore Creek, located in Shelby County, offering the perfect balance of style and functionality.",
      "page_copy": "Sycamore Creek offers three-bedroom floor plans in Shelby County with additional living space and flexible layouts. These apartment homes feature spacious interiors designed to support a variety of household needs.\n\nLocated in Sidney, our community includes high-speed internet access, emergency maintenance services, and laundry facilities in each building. Sycamore Creek combines modern apartment amenities with practical conveniences and access to local services throughout Shelby County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Floor Plans in Shelby County",
      "seo_description": "Discover spacious three-bedroom floor plans at Sycamore Creek, Shelby County. Perfect for anyone seeking comfort and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "page_item_url": "apartments-near-wilson-health-sidney-oh-sycamore-creek",
      "search_query": "apartments near Wilson Health Sidney OH",
      "category": "Hospital",
      "h1_title": "Apartments Near Wilson Health in Sidney, OH",
      "h2_subtitle": "Live minutes from Wilson Health at Sycamore Creek. Our Sidney, OH apartments offer convenience and comfort close to healthcare services.",
      "page_copy": "Sycamore Creek Apartments offers apartment homes conveniently located near Wilson Health in Sidney, OH. The community provides convenient access to healthcare facilities, local services, and nearby amenities.\n\nCommunity features include controlled access, professional on-site management, high-speed internet access, laundry facilities in each building, and emergency maintenance services. Sycamore Creek combines modern apartment amenities with practical conveniences and a location near Wilson Health and other destinations throughout Sidney.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Wilson Health, Sidney, OH",
      "seo_description": "Find convenient living near Wilson Health at Sycamore Creek in Sidney, OH. Enjoy great amenities and quick access to healthcare services.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "page_item_url": "apartments-near-tawawa-park-sidney-oh-sycamore-creek",
      "search_query": "apartments near Tawawa Park Sidney OH",
      "category": "Park",
      "h1_title": "Apartments Near Tawawa Park in Sidney, OH",
      "h2_subtitle": "Enjoy living near the picturesque Tawawa Park at Sycamore Creek. Our Sidney, OH apartments offer easy access to outdoor recreation.",
      "page_copy": "Nestled just a short distance from the scenic Tawawa Park, Sycamore Creek Apartments is your gateway to enjoying outdoor life in Sidney, OH. Our convenient location allows residents to indulge in the natural beauty and recreational activities at the park while also enjoying the comforts and amenities of home.\n\nSycamore Creek provides a host of features to enhance your living experience, including controlled access, high-speed internet, and on-site professional management. Plus, with laundry facilities in each building and dedicated emergency maintenance, you can enjoy a seamless blend of outdoor adventure and urban living in Sidney.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tawawa Park, Sidney, OH",
      "seo_description": "Live near Tawawa Park at Sycamore Creek in Sidney, OH. Enjoy outdoor activities and quality living with excellent amenities close by.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "page_item_url": "rentals-close-to-custenborder-field-45365-sycamore-creek",
      "search_query": "rentals close to Custenborder Field 45365",
      "category": "Park",
      "h1_title": "Rentals Close to Custenborder Field, 45365",
      "h2_subtitle": "Discover the convenience of living near Custenborder Field. Sycamore Creek rentals provide easy access to Sidney's sports and recreation facilities.",
      "page_copy": "Located in the heart of Sidney, OH, Sycamore Creek Apartments offers rentals conveniently close to Custenborder Field, home to thriving sports and community events. Whether you're an athlete or a sports enthusiast, you'll love the proximity to field activities and vibrant local gatherings.\n\nBeyond its ideal location, Sycamore Creek boasts a range of amenities designed for a modern lifestyle. Experience the benefits of high-speed internet access, controlled building entrances, and on-site professional management. With laundry facilities in each building and responsive emergency maintenance, our community ensures peace of mind and comfort in Sidney's 45365 area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Close to Custenborder Field, 45365",
      "seo_description": "Find rentals near Custenborder Field, Sidney, OH at Sycamore Creek. Enjoy a convenient location with modern amenities in the 45365 area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "page_item_url": "apartments-by-canal-feeder-trail-shelby-county-sycamore-creek",
      "search_query": "apartments by Canal Feeder Trail Shelby County",
      "category": "Park",
      "h1_title": "Apartments by Canal Feeder Trail, Shelby County",
      "h2_subtitle": "Experience the best of nature by living next to Canal Feeder Trail. Sycamore Creek apartments offer life amid Shelby County's natural beauty.",
      "page_copy": "Sycamore Creek Apartments in Sidney, OH, provide an exceptional living experience just moments away from Canal Feeder Trail. This prime location puts the beauty and tranquility of Shelby County's scenic landscapes right at your doorstep, making it perfect for nature lovers and outdoor enthusiasts.\n\nOffering spacious living with modern amenities, Sycamore Creek ensures comfort alongside nature. Enjoy conveniences like high-speed internet access, controlled access, and on-site professional management. Our community features laundry facilities in each building and reliable emergency maintenance, perfect for those seeking a balanced lifestyle near the Canal Feeder Trail.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Canal Feeder Trail, Shelby County",
      "seo_description": "Live near Canal Feeder Trail at Sycamore Creek, Shelby County. Enjoy nature and modern amenities in a serene Sidney, OH, setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167512",
      "source": "custom",
      "page_item_url": "housing-near-deam-park-sidney-sycamore-creek",
      "search_query": "housing near Deam Park in Sidney",
      "category": "Park",
      "h1_title": "Housing Near Deam Park in Sidney",
      "h2_subtitle": "Enjoy great housing options near Deam Park at Sycamore Creek. Our location in Sidney offers easy access to recreational activities.",
      "page_copy": "Sycamore Creek Apartments offers fantastic housing opportunities conveniently located near Deam Park in Sidney, OH. Enjoy the benefits of living close to this recreational hub, where leisurely walks, weekend picnics, and fun outdoor activities are part of everyday life.\n\nBeyond the prime location, our apartments come with features designed for modern convenience, such as high-speed internet, controlled access, and professional on-site management. Residents also benefit from having laundry facilities in each building and quick-response emergency maintenance, making Sycamore Creek an exceptional choice for those seeking housing near Deam Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing Near Deam Park, Sidney",
      "seo_description": "Discover Sycamore Creek housing near Deam Park in Sidney. Enjoy park proximity with modern amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12067692414"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5685519"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-N96MS7R3"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 3"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Prestige"
    },
    {
      "ID": "custom_tax_credit_properties",
      "type": "BOOLEAN",
      "value": "true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InhXTFRaSy96WU10TnlPK005RDN2Rnc9PSIsInZhbHVlIjoiQU5weDVjSVhIUmE1UFRzaHBIRFFxQT09IiwibWFjIjoiNWE0MTBiZGJkMmYwODc3MjgxMTQxMjdkZDk0NTdkMGFkZjU2M2YzZGYwMmE5NmE5ZWNlZjMwNjE3ZTU1MWMzMSJ9"
    }
  ],
  "custom_repli_id": "12067692414",
  "custom_realpage_id": "5685519",
  "custom_google_gtm_id": "GTM-N96MS7R3",
  "custom_rollout_phase": "Phase 3",
  "custom_vibesites_theme": "Prestige",
  "custom_tax_credit_properties": "true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InhXTFRaSy96WU10TnlPK005RDN2Rnc9PSIsInZhbHVlIjoiQU5weDVjSVhIUmE1UFRzaHBIRFFxQT09IiwibWFjIjoiNWE0MTBiZGJkMmYwODc3MjgxMTQxMjdkZDk0NTdkMGFkZjU2M2YzZGYwMmE5NmE5ZWNlZjMwNjE3ZTU1MWMzMSJ9",
  "custom_audioeye_site_id": "dd33b6f6-0a82-43ed-9f3a-5779aec9f3a5",
  "custom_audioeye_site_hash": "fa545332a873c5c360ec455ba9c5e341"
};

export const generatedAt = '2026-09-23T21:49:16.874Z';
